import styled from "styled-components";
export const InventoryWrapper = styled.div`
  background-color: #fff;
  width: 100%;
`;
